/* globals WEBPACK_GRAPHQL_URI */
export const IS_SERVER = typeof window === "undefined";
export const IS_BROWSER = !IS_SERVER;

const isTrue = value => ["yes", "true", "1", "on", "y"].includes(value.toLowerCase());

export const publicConfig = {
	ENV: process.env.ENV,
	NODE_ENV: process.env.NODE_ENV,
	PORT: process.env.PORT,
	BUILD_NUMBER: process.env.BUILD_NUMBER,
	RELEASE: process.env.RELEASE,
	LOCAL_URL: process.env.LOCAL_URL,

	STATIC_SITE_DOMAIN: process.env.STATIC_SITE_DOMAIN,
	GRAPHQL_URI: WEBPACK_GRAPHQL_URI,
	GRAPHQL_INTERNAL_URI: process.env.GRAPHQL_INTERNAL_URI,
	GRAPHQL_HEALTH_URL: process.env.GRAPHQL_HEALTH_URL,
	SB_CDN_HOST: process.env.SB_CDN_HOST,
	SITE_DOMAIN: process.env.SITE_DOMAIN,
	DA_DOMAIN: process.env.DA_DOMAIN,

	AWS_S3_PUBLIC_HOST: process.env.AWS_S3_PUBLIC_HOST,

	CI: process.env.CI,
	DEBUG_MODE: isTrue(process.env.DEBUG_MODE),
	COOKIE_NAME: process.env.COOKIE_NAME,

	VWO_ID: process.env.VWO_ID,
	GTM_ENV_NAME: process.env.GTM_ENV_NAME,
	RECURLY_PUBLIC_KEY: process.env.RECURLY_PUBLIC_KEY,

	SENTRY_DSN: process.env.SENTRY_DSN,
	SENTRY_ORG: process.env.SENTRY_ORG,
	SENTRY_PROJECT: process.env.SENTRY_PROJECT,
	SENTRY_TRACING_RATE: process.env.SENTRY_TRACING_RATE,
	SENTRY_SAMPLING_RATE: process.env.SENTRY_SAMPLING_RATE,

	HUBSPOT_PORTAL_ID: process.env.HUBSPOT_PORTAL_ID,
	HUBSPOT_CONTACT_US_FORM_ID: process.env.HUBSPOT_CONTACT_US_FORM_ID,
	HUBSPOT_FREE_COURSE_LICENSE_FORM_ID: process.env.HUBSPOT_FREE_COURSE_LICENSE_FORM_ID,
	HUBSPOT_ENTERPRISE_FORM_ID: process.env.HUBSPOT_ENTERPRISE_FORM_ID,
	HUBSPOT_LUMA_SCIENTIFIC_INTELLIGENCE_PLATFORM_FORM_ID:
		process.env.HUBSPOT_LUMA_SCIENTIFIC_INTELLIGENCE_PLATFORM_FORM_ID,

	// ISUL CONFIG
	IS_ISUL_GROUP_ENABLED: isTrue(process.env.IS_ISUL_GROUP_ENABLED),

	GOOGLE_RECAPTCHA_SITE_KEY: process.env.GOOGLE_RECAPTCHA_SITE_KEY,
	CASTLE_PUBLIC_KEY: process.env.CASTLE_PUBLIC_KEY,

	CTF_ENV: process.env.CTF_ENV,
	CTF_SPACE: process.env.CTF_SPACE,
	CTF_TOKEN: process.env.CTF_TOKEN,
	CTF_URL: process.env.CTF_URL,
	CTF_API_URL: process.env.CTF_API_URL,
	ZENDESK_URL: process.env.ZENDESK_URL,
	ZENDESK_EMAIL: process.env.ZENDESK_EMAIL,

	SB_CDN_BASE_URL: process.env.SB_CDN_BASE_URL,
	VERSION_NODE: process.env.VERSION_NODE,
	VERSION_NPM: process.env.VERSION_NPM,
};

export const contentfulProps = {
	environment: publicConfig.CTF_ENV,
	space: publicConfig.CTF_SPACE,
	accessToken: publicConfig.CTF_TOKEN,
	proxy: null,
};

export const privateConfig = {
	...publicConfig,
	CTF_CMA_TOKEN: process.env.CTF_CMA_TOKEN,
	ZENDESK_TOKEN: process.env.ZENDESK_TOKEN,
	REVALIDATE_SECRET: process.env.REVALIDATE_SECRET,
};
